export default __webpack_public_path__ + "static/media/Bangles of the Faceless Sphinx.eeb68742.jpg";